import React from 'react'
import ActionCard from './ActionCard';
import { styled } from "../../../stitches.config";

type ActionCardTypes = {
    text: string,
    title: string,
    video: string,
}

const ActionCards: ActionCardTypes[] = [
    {
        title: 'Bilboard na Times Square',
        text: 'Pamiętacie obchody stulecia odzyskania przez Polskę niepodległości? Nieoczekiwanie 11 listopada 2018 roku na nowojorskim Times Square pojawiła się gigantyczna reklama Polski. Ale naprawdę gigantyczna, bo na największym dostępnym tam banerze. To właśnie my wynajęliśmy ten baner. Po prostu chcieliśmy pokazać wszystkim, jak fajna jest Polska. Akcja z miejsca stała się viralem w polskim internecie, informowały o niej także konkurencyjne media, w tym telewizyjne(główne wydanie "Wydarzeń" w Polsacie).',
        video: 'https://www.youtube.com/embed/jtKRJokmToM',
    },
    {
        title: 'Polacy głosujcie!',
        text: 'A kojarzycie film "Trzy Billboardy za Ebbing, Missouri"? Ta produkcja, która błyskawicznie stała się kultowa, zainspirowała nas do stworzenia kolejnej akcji – tym razem profrekwencyjnej przed wyborami parlamentarnymi w 2019. Po prostu postawiliśmy swoje trzy billboardy, tyle że...za Sieradzem.Z początku nic nas nie łączyło z tą akcją, zresztą ukryliśmy nasz prawdziwy motyw. Po sieci krążyły różne domysły, pojawiły się nawet wątki matrymonialne.Ale od początku chodziło nam tylko o udział w tym wyjątkowym święcie demokracji.',
        video: 'https://www.youtube.com/embed/5oZbKZg1uLQ',
    },
    {
        title: 'Mural dla medyków',
        text: 'Ta akcja – ze wszystkich, które zrobiliśmy – odbiła się jednak największym echem na świecie. W szczycie kryzysu związanego z epidemią koronawirusa wynajęliśmy jedną z najlepiej wyeksponowanych w Warszawie ścian pod mural. I umieściliśmy na niej podziękowania dla prawdziwych bohaterów naszych czasów – medyków. Nasz mural opisała cała masa polskich mediów i wiele zagranicznych(nawet w Chinach czy Indiach!), pokazywali go politycy wielu opcji, w tym Donald Tusk.',
        video: 'https://www.youtube.com/embed/Me4eg_R1kpQ',
    },
]


const Actions = () => {
    return (
        <ActionsWrapper>
            {
                ActionCards.map((item, index) => {
                    return (
                        <ActionCard text={item.text} title={item.title} video={item.video} key={index} />
                    )
                })
            }
        </ActionsWrapper>
    )
}

export default Actions;

const ActionsWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '56px',
    width: '100%',
    marginTop: '56px',
    '@bp4': {
        flexDirection: 'column',
        gap: '193px',
        marginTop: '128px',
    }
})
